import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const AmountDueAtSigningPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Amount Due at Signing</Text>
            </View>

            <View>
                {
                    pdfData.amount_due_at_signing_breakdown.map((value) => {
                        if (value.amount === "0") return null;
                        return (
                            <View
                                key={`${value.name}${value.amount}`}
                                style={baseStyles.flexBetween}
                            >
                                <Text>{value.name}</Text>
                                <Text>{value.amount.toDollarFormat()}</Text>
                            </View>
                        )
                    })
                }
                {/*<View style={baseStyles.flexBetween}>*/}
                {/*    <Text>1st Month Payment</Text>*/}
                {/*    <Text>{pdfData.monthly_payment.toDollarFormat() }</Text>*/}
                {/*</View>*/}

                {/*<View style={baseStyles.flexBetween}>*/}
                {/*    <Text>Fees</Text>*/}
                {/*    <Text>{pdfData.total_fees.toDollarFormat()}</Text>*/}
                {/*</View>*/}

                {/*<View style={{...baseStyles.flexBetween}}>*/}
                {/*    <Text>Upfront Taxes</Text>*/}
                {/*    <Text>*/}
                {/*        /!*{helper.upfrontTaxes().toDollarFormat()}*!/*/}
                {/*        <Text>{pdfData.upfront_taxes.toDollarFormat()}</Text>*/}
                {/*    </Text>*/}
                {/*</View>*/}

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text
                    >
                        Total Inception Fees
                    </Text>
                    <Text>
                        {pdfData.total_inception_fees.toDollarFormat()}
                    </Text>
                </View>

                {
                    pdfData.cap_reduction_cash !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Cap Reduction (Cash)</Text>
                        <Text>
                            <Text>{pdfData.cap_reduction_cash.toDollarFormat()}</Text>
                        </Text>
                    </View>
                }
                {
                    pdfData.cap_reduction_cash_tax && pdfData.cap_reduction_cash_tax !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Cap Reduction Cash Tax</Text>
                        <Text>
                            <Text>{pdfData.cap_reduction_cash_tax.toDollarFormat()}</Text>
                        </Text>
                    </View>
                }
                {
                    pdfData.capitalized_inception_fees !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text>Capitalized Inception Fees</Text>
                        <Text>
                            {(Number(pdfData.capitalized_inception_fees) * -1 ).toDollarFormat()}
                        </Text>
                    </View>
                }
                {
                    pdfData.rebate_as_drive_off && pdfData.rebate_as_drive_off !== '0' &&
                    <View style={{...baseStyles.flexBetween}}>
                        <Text
                        >
                            Rebate as Drive Off
                        </Text>
                        <Text
                        >{Number(pdfData.rebate_as_drive_off * -1).toDollarFormat()}</Text>
                    </View>
                }


                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text
                    >
                        Total Drive Off
                    </Text>
                    <Text
                    >{pdfData.cash_due_on_delivery.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}